module.exports = __webpack_public_path__ + "static/media/contact_1.6e660f15.jpg";